export default __webpack_public_path__ + "static/media/Japri app.1e6b27da.png";